import { conditions } from "helpers";
import { ConditionName } from "interfaces";
import { useAppSelector } from "redux-share/hooks";
import { shallowEqual } from "react-redux";

const Title = () => {
    const { details, params } = useAppSelector(({ videoData: { details, params } }) => ({ details, params }), shallowEqual);

    return (
        <div
            className={`pl-mr-3 pl-text-[14px] pl-font-medium pl-text-white pl-break-words pl-self-start animate__animated animate__faster ${
                conditions(ConditionName.isActiveElements) ? "animate__fadeIn pl-opacity-100" : "pl-opacity-0 animate__fadeOut"
            }`}
        >
            {conditions(ConditionName.hasTitle) ? details.title : params.id}
        </div>
    );
};

export default Title;
